import React from "react";
import { DocumentRenderer } from "components";
import PaySlipDetail from "./PaySlipDetail";

export default ({
  item,
  t,
  client,
  settings: settingsProp,
  selectedOrganisation,
  ...props
}) => {
  const [settings, setSettings] = React.useState(settingsProp);

  const onMount = async () => {
    if (settings) return;

    const s = await client
      .get(`payroll/${selectedOrganisation.id}/settings/1/public`)
      .get("data");
    setSettings(s);
  };
  React.useEffect(() => void onMount(), []);

  if (!settings) return null;

  return (
    <DocumentRenderer {...props}>
      <div className="container-fluid m-0 p-0">
        <PaySlipDetail item={item} settings={settings} />
      </div>
    </DocumentRenderer>
  );
};
